export default __webpack_public_path__ + "621a0eeb683166473720f7341024aa63.mp3";